/**
 * [Orders 个人中心]
 * @type {Array}
 */
export default [{
    path: 'order',
    name: 'order',
    redirect: 'order/person_order_list',
    component: resolve => require(['@/views/center/order'], resolve),
    meta: {
      title: '订单中心',
      auth: true
    },
    children: [
      // 个人订单
      {
        path: 'person_order_list',
        name: 'person_order_list',
        component: resolve => require(['@/views/person/orderList'], resolve),
        meta: {
          title: '历史订单',
          auth: true
        },
      },
      // 团体订单
      {
        path: 'team_order_list',
        name: 'team_order_list',
        component: resolve => require(['@/views/team/orderList'], resolve),
        meta: {
          title: '历史订单',
          auth: true
        },
      },
    ]
  },
  {
    path: 'center',
    name: 'center',
    redirect: '/center/travel_base_info',
    component: resolve => require(['@/views/center/travel'], resolve),
    meta: {
      title: '个人中心',
      auth: true
    },
    children: [
      // 旅行社预约
      {
        path: 'travel_base_info',
        name: 'travel_base_info',
        component: resolve => require(['@/views/travel/baseInfo'], resolve),
        meta: {
          title: '旅行社预约',
          auth: true
        },
      },
      {
        path: 'travel_order_list',
        name: 'travel_order_list',
        component: resolve => require(['@/views/travel/orderList'], resolve),
        meta: {
          title: '旅行社预约',
          auth: true
        },
      },

    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/center.js